/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      userId
      type
      name
      userPhotoPath
      firstName
      lastName
      email
      flowId
      stepId
      description
      birthDay
      address
      address2
      FaceId
      postalCode
      city
      gender
      extended
      createdAt
      updatedAt
      status
      tags
      group
      subgroups
      owner
      searchField
      flow
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      userId
      type
      name
      userPhotoPath
      firstName
      lastName
      email
      flowId
      stepId
      description
      birthDay
      address
      address2
      FaceId
      postalCode
      city
      gender
      extended
      createdAt
      updatedAt
      status
      tags
      group
      subgroups
      owner
      searchField
      flow
    }
  }
`;
export const createTemplate = /* GraphQL */ `
  mutation CreateTemplate($input: CreateTemplateInput!) {
    createTemplate(input: $input) {
      id
      name
      description
      createdAt
      updatedAt
      schema
      status
      uischema
      document {
        nextToken
      }
      tags
      group
      subgroups
      owner
      html
      fileUrl
      searchField
      signaturesPositions {
        pageNumber
        rects
      }
    }
  }
`;
export const updateTemplate = /* GraphQL */ `
  mutation UpdateTemplate($input: UpdateTemplateInput!) {
    updateTemplate(input: $input) {
      id
      name
      description
      createdAt
      updatedAt
      schema
      status
      uischema
      document {
        nextToken
      }
      tags
      group
      subgroups
      owner
      html
      fileUrl
      searchField
      signaturesPositions {
        pageNumber
        rects
      }
      defaultValues
      defaultValuesForm
    }
  }
`;
export const createDocument = /* GraphQL */ `
  mutation CreateDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      id
      name
      description
      data
      status
      fileUrl
      type
      hash
      createdAt
      updatedAt
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      bundle {
        id
        name
        description
        status
        fileUrl
        fileUrlTemplate
        type
        createdAt
        updatedAt
        flowTemplateId
        tags
        flowId
        owner
        subgroups
        group
        searchField
        flow
      }
      tags
      flowId
      annexes {
        name
        path
        description
        skip
      }
      principal {
        name
        path
        description
        skip
      }
      owner
      subgroups
      html
      group
      searchField
      bundleId
      flow
      markAsRead
    }
  }
`;
export const updateDocument = /* GraphQL */ `
  mutation UpdateDocument($input: UpdateDocumentInput!) {
    updateDocument(input: $input) {
      id
      name
      description
      data
      status
      fileUrl
      type
      hash
      createdAt
      updatedAt
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      bundle {
        id
        name
        description
        status
        fileUrl
        fileUrlTemplate
        type
        createdAt
        updatedAt
        flowTemplateId
        tags
        flowId
        owner
        subgroups
        group
        searchField
        flow
      }
      tags
      flowId
      annexes {
        name
        path
        description
        skip
      }
      principal {
        name
        path
        description
        skip
      }
      owner
      subgroups
      html
      group
      searchField
      bundleId
      flow
      markAsRead
    }
  }
`;
export const createBundle = /* GraphQL */ `
  mutation CreateBundle($input: CreateBundleInput!) {
    createBundle(input: $input) {
      id
      name
      description
      status
      fileUrl
      fileUrlTemplate
      type
      createdAt
      updatedAt
      flowTemplateId
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      tags
      flowId
      owner
      subgroups
      group
      searchField
      document {
        nextToken
      }
      flow
    }
  }
`;
export const updateBundle = /* GraphQL */ `
  mutation UpdateBundle($input: UpdateBundleInput!) {
    updateBundle(input: $input) {
      id
      name
      description
      status
      fileUrl
      fileUrlTemplate
      type
      createdAt
      updatedAt
      flowTemplateId
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      tags
      flowId
      owner
      subgroups
      group
      searchField
      document {
        nextToken
      }
      flow
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification($input: CreateNotificationInput!) {
    createNotification(input: $input) {
      id
      type
      data
      createdAt
      updatedAt
      visible
      read
      owner
      group
      subgroups
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      id
      type
      data
      createdAt
      updatedAt
      visible
      read
      owner
      group
      subgroups
    }
  }
`;
